// extracted by mini-css-extract-plugin
export default {"wrapper":"Notification_wrapper__xi9wV","close":"Notification_close__ipidX"};